export default __webpack_public_path__ + "static/logo-doktorkladivo-cfd049f276eecee88d7e708206194d8a.png";